import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class Banner extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get image() {
    return get(this, '_image.value[0].url', '');
  }

  get text() {
    return get(this, '_text.value', '');
  }

  get buttonText() {
    return get(this, '_button_text.value', '');
  }

  get buttonLink() {
    return get(this, '_button_link.value', '');
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/Banner.model.js